import React, { useState, useCallback, useRef } from 'react';
import { Image, Platform, Pressable, StyleSheet, Text, View, useWindowDimensions } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import {NavigationProp, ParamListBase} from '@react-navigation/native';

interface HeaderLeftProps {
  navigation: NavigationProp<ParamListBase>;
  title?: string,
  children?: React.ReactNode;
  forceNoBackButton: boolean;
  noFiltersRight: boolean;
};

const styles = StyleSheet.create({
  backButtonWrapper: {
    flexDirection: "row",
    alignItems: "center",
    ...Platform.select({
      ios: {
        paddingLeft: 0,
      },
      default: {
        paddingLeft: 10,
      },
    }),
  },
  backButtonImage: {
    ...Platform.select({
      ios: {
        width: 24,
        height: 24,
      },
      default: {
        width: 24,
        height: 24,
      },
    }),
  },
  noBackButtonWrapper: {
    paddingLeft: 16,
    flexDirection: "row",
  },
});

const HIT_SLOP = { top: 10, bottom: 10, left: 30, right: 30 };

// https://github.com/react-navigation/react-navigation/blob/main/packages/stack/src/views/Header/Header.tsx
// https://github.com/react-navigation/react-navigation/blob/main/packages/stack/src/views/Header/HeaderSegment.tsx
// https://github.com/react-navigation/react-navigation/blob/main/packages/elements/src/Header/HeaderBackButton.tsx#L16
export const HeaderLeft = ({ navigation, children, title, forceNoBackButton, noFiltersRight }: HeaderLeftProps) => {
  const { width, height } = useWindowDimensions();
  if (title && !children) {
    if (!noFiltersRight) {
      children = <Text
                  selectable={true}
                  style={[AppConstants.STYLES.fontSize17, {width: width - 60 - AppConstants.getFilterImagesSize()}]}
                  numberOfLines={1}
                  ellipsizeMode={"tail"}>{title}</Text>;
    } else {
      children = <Text
                  selectable={true}
                  style={[AppConstants.STYLES.fontSize17, {width: width - 60}]}
                  numberOfLines={1}
                  ellipsizeMode={"tail"}>{title}</Text>;
    }
  }
  if (navigation.canGoBack() && !forceNoBackButton) {
    return (
      <View style={styles.backButtonWrapper}>
        <Pressable
          onPress={() => {
            navigation.goBack();
          }}
          hitSlop={HIT_SLOP}
        >
          <Image
            source={require("../../assets/iphoneback2.png")}
            style={styles.backButtonImage}
          />
        </Pressable>
        { children }
      </View>
    );
  } else {
    return (
      <View style={styles.noBackButtonWrapper}>
        { children }
      </View>
    );
  }
};
